import { render, staticRenderFns } from "./ListNewsletter.vue?vue&type=template&id=f180549a"
import script from "./ListNewsletter.vue?vue&type=script&lang=js"
export * from "./ListNewsletter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports